import { FlosIcon, InfoBox } from '@flos/react-ui';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { TrailerOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/uvp';

const TrailerInfoBox = ({
    isTrailerFound,
    coverable
}: {
    isTrailerFound: boolean | undefined;
    coverable: TrailerOnsaDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    const getInfoBoxLabel = (): string => {
        if (isTrailerFound) {
            return 'Påhængsvogn';
        } else if (isTrailerFound === undefined) {
            return '';
        }
        return getHippoText('DSS-COVERABLE-INFORMATION-STEP-LICENSE-PLATE-NO-MATCH');
    };

    const getInfoBoxTitle = (): string => {
        if (isTrailerFound) {
            return `${String(coverable.make)} ${String(coverable.model)}`;
        } else if (isTrailerFound === undefined) {
            return '';
        }
        return getHippoText('DSS-COVERABLE-INFORMATION-STEP-LICENSE-PLATE-CHECK-LICENSE-PLATE');
    };

    return (
        <InfoBox
            className="u-spacing-inset-bottom-4"
            iconShape={'trailer'}
            label={getInfoBoxLabel()}
            title={getInfoBoxTitle()}
            text={isTrailerFound ? coverable.year?.toString() : ''}
            actionArea={
                isTrailerFound !== undefined && (
                    <FlosIcon
                        className={isTrailerFound ? 'is-green has-fill' : 'is-red has-fill'}
                        shape={isTrailerFound ? 'circle-check' : 'circle-close'}
                        size={'medium'}
                    />
                )
            }
        />
    );
};

export default TrailerInfoBox;
